import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelFrench_afnor: KeyLabel[] = [
  {
    code: 4,
    label: 'Q',
    meta: [
      {
        label: 'θ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'B',
    meta: [
      {
        label: '− (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: 'ç',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
    meta: [
      {
        label: '¤ (dead monetary key)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: 'G',
    meta: [
      {
        label: 'µ (dead Greek key)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 11,
    label: 'H',
    meta: [
      {
        label: 'Eu (dead European symbol key)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ˍ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ˍ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 12,
    label: 'I',
    meta: [
      {
        label: '˙ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̣ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̣ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
    meta: [
      {
        label: '∕ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: '.',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¿',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
    meta: [
      {
        label: 'œ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‰',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‰',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'A',
    meta: [
      {
        label: 'æ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
    meta: [
      {
        label: '®',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
    meta: [
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 24,
    label: 'U',
    meta: [
      {
        label: 'ù',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 25,
    label: 'V',
    meta: [
      {
        label: '¸ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˛ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˛ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 26,
    label: 'Z',
    meta: [
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
    meta: [
      {
        label: '©',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'Y',
    meta: [
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'W',
    meta: [
      {
        label: 'ʒ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: 'à',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: 'é',
    meta: [
      {
        label: '2',
        modifiers: MOD.SFT,
      },
      {
        label: '2',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: 'è',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: 'ê',
    meta: [
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '(',
    meta: [
      {
        label: '5',
        modifiers: MOD.SFT,
      },
      {
        label: '5',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: ')',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̏ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̏ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '‘',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¯ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '’',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '—',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '—',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '«',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '“',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‹',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‹',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '»',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '”',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '›',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '›',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: "'",
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˚ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˚ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '^ (dead)',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'ˇ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: '-',
    meta: [
      {
        label: '–',
        modifiers: MOD.SFT,
      },
      {
        label: '–',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '−',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‑ (non-breaking hyphen)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‑ (non-breaking hyphen)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: '+',
    meta: [
      {
        label: '±',
        modifiers: MOD.SFT,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '†',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‡',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‡',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: '*',
    meta: [
      {
        label: '½',
        modifiers: MOD.SFT,
      },
      {
        label: '½',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¼',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¼',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'M',
    meta: [
      {
        label: '∞',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: '/',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.SFT,
      },
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '√',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '√',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '@',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˘ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̑ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̑ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¡',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̦ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: ' ̦ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: ':',
    meta: [
      {
        label: '…',
        modifiers: MOD.SFT,
      },
      {
        label: '…',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '·',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: ';',
    meta: [
      {
        label: '=',
        modifiers: MOD.SFT,
      },
      {
        label: '=',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≃',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≠',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≠',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: '<',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≤',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 528,
    label: '?',
  },
  {
    code: 542,
    label: '1',
  },
  {
    code: 543,
    label: '2',
  },
  {
    code: 544,
    label: '3',
  },
  {
    code: 545,
    label: '4',
  },
  {
    code: 546,
    label: '5',
  },
  {
    code: 547,
    label: '6',
  },
  {
    code: 548,
    label: '7',
  },
  {
    code: 549,
    label: '8',
  },
  {
    code: 550,
    label: '9',
  },
  {
    code: 551,
    label: '0',
  },
  {
    code: 557,
    label: '"',
  },
  {
    code: 558,
    label: '¨ (dead)',
  },
  {
    code: 559,
    label: '–',
  },
  {
    code: 560,
    label: '±',
  },
  {
    code: 562,
    label: '½',
  },
  {
    code: 564,
    label: '(backslash)',
  },
  {
    code: 565,
    label: '#',
  },
  {
    code: 566,
    label: '!',
  },
  {
    code: 567,
    label: '…',
  },
  {
    code: 568,
    label: '=',
  },
  {
    code: 612,
    label: '>',
  },
  {
    code: 4624,
    label: '?',
  },
  {
    code: 4638,
    label: '1',
  },
  {
    code: 4639,
    label: '2',
  },
  {
    code: 4640,
    label: '3',
  },
  {
    code: 4641,
    label: '4',
  },
  {
    code: 4642,
    label: '5',
  },
  {
    code: 4643,
    label: '6',
  },
  {
    code: 4644,
    label: '7',
  },
  {
    code: 4645,
    label: '8',
  },
  {
    code: 4646,
    label: '9',
  },
  {
    code: 4647,
    label: '0',
  },
  {
    code: 4653,
    label: '"',
  },
  {
    code: 4654,
    label: '¨ (dead)',
  },
  {
    code: 4655,
    label: '–',
  },
  {
    code: 4656,
    label: '±',
  },
  {
    code: 4658,
    label: '½',
  },
  {
    code: 4660,
    label: '(backslash)',
  },
  {
    code: 4661,
    label: '#',
  },
  {
    code: 4662,
    label: '!',
  },
  {
    code: 4663,
    label: '…',
  },
  {
    code: 4664,
    label: '=',
  },
  {
    code: 4708,
    label: '>',
  },
  {
    code: 5124,
    label: 'θ',
  },
  {
    code: 5125,
    label: '− (dead)',
  },
  {
    code: 5126,
    label: 'ç',
  },
  {
    code: 5127,
    label: '$',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5129,
    label: '¤ (dead monetary key)',
  },
  {
    code: 5130,
    label: 'µ (dead Greek key)',
  },
  {
    code: 5131,
    label: 'Eu (dead European symbol key)',
  },
  {
    code: 5132,
    label: '˙ (dead)',
  },
  {
    code: 5134,
    label: '∕ (dead)',
  },
  {
    code: 5135,
    label: '|',
  },
  {
    code: 5136,
    label: '¿',
  },
  {
    code: 5137,
    label: '~ (dead)',
  },
  {
    code: 5138,
    label: 'œ',
  },
  {
    code: 5139,
    label: '%',
  },
  {
    code: 5140,
    label: 'æ',
  },
  {
    code: 5141,
    label: '®',
  },
  {
    code: 5142,
    label: 'ß',
  },
  {
    code: 5143,
    label: '{',
  },
  {
    code: 5144,
    label: 'ù',
  },
  {
    code: 5145,
    label: '¸ (dead)',
  },
  {
    code: 5146,
    label: '£',
  },
  {
    code: 5147,
    label: '©',
  },
  {
    code: 5148,
    label: '}',
  },
  {
    code: 5149,
    label: 'ʒ',
  },
  {
    code: 5150,
    label: '§',
  },
  {
    code: 5151,
    label: '´ (dead)',
  },
  {
    code: 5152,
    label: '` (dead)',
  },
  {
    code: 5153,
    label: '&',
  },
  {
    code: 5154,
    label: '[',
  },
  {
    code: 5155,
    label: ']',
  },
  {
    code: 5156,
    label: '¯ (dead)',
  },
  {
    code: 5157,
    label: '_',
  },
  {
    code: 5158,
    label: '“',
  },
  {
    code: 5159,
    label: '”',
  },
  {
    code: 5165,
    label: '°',
  },
  {
    code: 5166,
    label: 'ˇ (dead)',
  },
  {
    code: 5167,
    label: '−',
  },
  {
    code: 5168,
    label: '†',
  },
  {
    code: 5170,
    label: '×',
  },
  {
    code: 5171,
    label: '∞',
  },
  {
    code: 5172,
    label: '÷',
  },
  {
    code: 5173,
    label: '˘ (dead)',
  },
  {
    code: 5174,
    label: '¡',
  },
  {
    code: 5175,
    label: '·',
  },
  {
    code: 5176,
    label: '≃',
  },
  {
    code: 5220,
    label: '≤',
  },
  {
    code: 5643,
    label: 'ˍ (dead)',
  },
  {
    code: 5643,
    label: 'ˍ (dead)',
  },
  {
    code: 5644,
    label: ' ̣ (dead)',
  },
  {
    code: 5644,
    label: ' ̣ (dead)',
  },
  {
    code: 5651,
    label: '‰',
  },
  {
    code: 5651,
    label: '‰',
  },
  {
    code: 5655,
    label: '™',
  },
  {
    code: 5655,
    label: '™',
  },
  {
    code: 5657,
    label: '˛ (dead)',
  },
  {
    code: 5657,
    label: '˛ (dead)',
  },
  {
    code: 5666,
    label: '˝ (dead)',
  },
  {
    code: 5666,
    label: '˝ (dead)',
  },
  {
    code: 5667,
    label: ' ̏ (dead)',
  },
  {
    code: 5667,
    label: ' ̏ (dead)',
  },
  {
    code: 5669,
    label: '—',
  },
  {
    code: 5669,
    label: '—',
  },
  {
    code: 5670,
    label: '‹',
  },
  {
    code: 5670,
    label: '‹',
  },
  {
    code: 5671,
    label: '›',
  },
  {
    code: 5671,
    label: '›',
  },
  {
    code: 5677,
    label: '˚ (dead)',
  },
  {
    code: 5677,
    label: '˚ (dead)',
  },
  {
    code: 5679,
    label: '‑ (non-breaking hyphen)',
  },
  {
    code: 5679,
    label: '‑ (non-breaking hyphen)',
  },
  {
    code: 5680,
    label: '‡',
  },
  {
    code: 5680,
    label: '‡',
  },
  {
    code: 5682,
    label: '¼',
  },
  {
    code: 5682,
    label: '¼',
  },
  {
    code: 5684,
    label: '√',
  },
  {
    code: 5684,
    label: '√',
  },
  {
    code: 5685,
    label: ' ̑ (dead)',
  },
  {
    code: 5685,
    label: ' ̑ (dead)',
  },
  {
    code: 5686,
    label: ' ̦ (dead)',
  },
  {
    code: 5686,
    label: ' ̦ (dead)',
  },
  {
    code: 5688,
    label: '≠',
  },
  {
    code: 5688,
    label: '≠',
  },
  {
    code: 5732,
    label: '≥',
  },
  {
    code: 5732,
    label: '≥',
  },
];
